'use client'
import { __rest } from '../../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { Typography } from '../Typography/Typography.js';
import { Button } from '../Button/Button.js';

const TypographyButton = (_a) => {
    var _b;
    var { children, typographyProps = {
        variant: 'button_primary',
    }, copykey } = _a, props = __rest(_a, ["children", "typographyProps", "copykey"]);
    return (jsx(Button, Object.assign({}, props, { children: jsx(Typography, Object.assign({ variant: 'button_primary', as: 'span' }, typographyProps, { color: (_b = typographyProps.color) !== null && _b !== void 0 ? _b : 'primary', copykey: copykey, children: children })) })));
};

export { TypographyButton };
